
<template>
   <!-- choose us area start -->
    <div class="why-choose-us-area bg-gray pd-top-90 pd-bottom-60">
        <div class="container">
            <div class="section-title text-center">
                <h2 class="title">Why Choose Us</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-3 col-lg-4 col-sm-6">
                    <div class="single-intro text-lg-left text-center">
                        <div class="thumb">
                            <img src="assets/img/icons/12.png" alt="img">
                        </div>
                        <div class="details">
                            <h4 class="title"><a href="#">Affordability and Flexibility of Payment </a></h4>
                            <p>While we offer premium service, our properties are relatively affordable. Whether you subscribe to an instalment or mortgage, our payment plans are quite flexible and easy to fulfil.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-sm-6 offset-xl-1">
                    <div class="single-intro text-lg-left text-center">
                        <div class="thumb">
                             <img src="assets/img/icons/11.png" alt="img">
                        </div>
                        <div class="details">
                            <h4 class="title"><a href="#">Certificate of Occupancy</a></h4>
                            <p>Our estates have a certificate of occupancy and other cogent documents backed by the state’s authority. This eliminates concerns that border on government’s forceful reacquisition.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-sm-6 offset-xl-1">
                    <div class="single-intro text-lg-left text-center">
                        <div class="thumb">
                            <img src="assets/img/icons/13.png" alt="img">
                        </div>
                        <div class="details">
                            <h4 class="title"><a href="#">Guaranteed Security</a></h4>
                            <p>Your safety is assured, each minute of each day. Our real-time monitored state-of-the-art security system provides surveillance for your perimeter and select areas of your interior. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- choose us start -->
  
</template>

<script>
export default {
  name: "ChooseUs",
  
};
</script>


<style>

</style>





 


